import { IAdminWorkSend } from 'src/types/adminWork';
import { AdminWorkFormData } from 'src/screens/General/screens/AdminWork/components/AdminWorkForm';
import moment from 'moment';

const groupAdminWork = (dataForm: Partial<AdminWorkFormData>): Partial<IAdminWorkSend> => {
    const { startTime, endTime, providerDropDown, ...data } = dataForm;
    const dataSend: Partial<IAdminWorkSend> = { ...data };

    if (data.adminWorkDate) {
        dataSend.adminWorkDate = moment(data.adminWorkDate).format('YYYY-M-D');
    }

    if (startTime && data.adminWorkDate) {
        const hoursStart = +moment(startTime).format('H');
        const minStart = +moment(startTime).format('m');

        dataSend.startTime = moment(data.adminWorkDate)
            .set('hour', hoursStart)
            .set('minute', minStart)
            .format('YYYY-M-D H:m:ss');
    }
    if (endTime && data.adminWorkDate) {
        const hoursEnd = +moment(endTime).format('H');

        const minEnd = +moment(endTime).format('m');
        dataSend.endTime = moment(data.adminWorkDate)
            .set('hour', hoursEnd)
            .set('minute', minEnd)
            .format('YYYY-M-D H:m:ss');

        //dataSend.endTime = moment(`${moment(seanceDate).format('L')}-${moment(endTime).format('LT')}`).format();
    }
    if (providerDropDown) {
        dataSend.provider = providerDropDown.value;
    }
    return dataSend;
};
export { groupAdminWork };
